export default __webpack_public_path__ + "static/thumbnail_screenshot-99ec5b5ca98463b6b917dd34f4035faa.png";